import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import FrontPage from './pages/FrontPage';
import EditPage from './pages/EditPage';
import DetailPage from './pages/DetailPage';
import HistoryPage from './pages/HistoryPage';

// import { ScrollToTop } from "./components/scroll/ScrollToTop";
import './assets/css/style.css';

function App() {
    return (
        <BrowserRouter basename={process.env.PUBLIC_URL}>
            {/* <ScrollToTop />  */}
            <Routes>
                <Route path="/" element={<FrontPage />} />
                <Route path="/edit/:id" element={<EditPage />} />
                <Route path="/detail/:id" element={<DetailPage />} />
                <Route path="/history" element={<HistoryPage />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
